(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-list-butttons"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get("reverse-slider")) {
    class ReverseSlider extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.abortController = new AbortController();
        this.scrollEl = this.querySelector('[data-scroll-el]');

        this.addEventListener('wheel', this.onWheelScroll.bind(this), {
          signal: this.abortController.signal
        })
        const activeItem = this.querySelector('.active');

        if(activeItem) {
          activeItem.scrollIntoView({
            container: "nearest",
            inline: "center",
          })
        }
      }

      onWheelScroll(evt) {
        let preventMovement = false;
        if((evt.deltaY > 0 && this.scrollEl.scrollLeft + this.scrollEl.clientWidth < this.scrollEl.scrollWidth) ||
          (evt.deltaY < 0 && this.scrollEl.scrollLeft > 0)) {
            preventMovement = true;
        }

        if(preventMovement == true) {
          evt.preventDefault();
          evt.stopPropagation();
        }

        this.scrollEl.scrollTo(
          {
            left: this.scrollEl.scrollLeft += evt.deltaY,
            behavior: "smooth"
          }
        );
      }

      disconnectedCallback() {
        this.abortController.abort();
      }
    }
    customElements.define("reverse-slider", ReverseSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
